<template>
  <NaviLink
    :label="''"
    :href="props.href"
    :is-active-validator="() => (false)"
    class="navi-link-logo"
  >
    <span class="navi-button-logo-discernible-name">Statementdog</span>
    <img
      :src="SVG_STRING.STATMENTDOG_LOGO"
      alt="statementdog logo"
    >
  </NaviLink>
</template>

<script setup>
import SVG_STRING from '../../constants/navi_svg_sprite'

import NaviLink from './NaviLink.vue'

const props = defineProps({
  href: {
    type: String,
    default: '/',
  },
})
</script>

<style scoped lang="scss">
.navi-link-logo {
  display: block;
  width: 36px;
  height: 36px;
  padding-top: 12px;
  padding-bottom: 6px;

  @media screen and (min-width: 64em) {
    padding-left: 12px;
    padding-right: 12px;
  }

  .navi-button-logo-discernible-name {
    width: 1px;
    height: 1px;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
